require('./bootstrap');
global.$ = global.jQuery = require('jquery');

require('select2/dist/js/select2.full');
$(function () {
    $('[data-toggle="select2"]').removeClass('select2-hidden').select2();
})

import bus from './lib/Bus';
window.bus = bus;


import Vue from 'vue';
import store from './store/public';
import {i18n} from "./lang";

Vue.component('country-select', require('./components/CountrySelect').default);
Vue.component('login-type', require('./components/LoginType.vue').default);
Vue.component('master-conditions-modal', require('./components/master/ConditionsModal').default);
Vue.component('contact-modal', require('./components/ContactModal').default);
Vue.component('contact-modal-link', require('./components/ContactModalLink').default);
Vue.component('signup-modal', require('./components/SignupModal.vue').default);
Vue.component('signup-button-wrapper', require('./components/SignupButtonWrapper').default);

const app = new Vue(
    {
        store,
        el: '#app',
        i18n,
    }
);
